import React from 'react';
import { Text } from '@aws-amplify/ui-react';
import './EyebrowGroupLabel.css';

// ── Design convention ─────────────────────────────────────────────────────────
// Both `EyebrowGroupLabel` (admin) and `Eyebrow` (src/components/common/Eyebrow)
// implement the same small-caps spec: 12px / 500 / 0.13em / uppercase / Stone Rose.
//
// `EyebrowGroupLabel` is the **admin-surface variant** — it wraps the shared
// `.geisti-eyebrow` typography class with Amplify `Text` for vertical rhythm
// and the Stone Rose color token. `Eyebrow` is the lightweight common variant for
// non-admin surfaces (shopify-app, shared components).
//
// The eyebrow is flush-left so it aligns with whatever body content follows it
// (card field labels, sidebar nav items). Surfaces that need their own left
// indent (e.g. the sidebar group headings) wrap the call with their own padding.
//
// Rule: never define a third eyebrow style. If you need the spec on a new surface,
// choose one of these two and extend via an additional class if layout differs.
//
// Contrast: brand.primary.60 = #9C5958 on surface.base = #F7F3EE → 4.77:1
// (WCAG AA for normal text ≥4.5:1 and large text ≥3:1). Verified 2026-05.
// ─────────────────────────────────────────────────────────────────────────────

interface Props {
  children: React.ReactNode;
}

const EyebrowGroupLabel = ({ children }: Props) => (
  <Text
    role="presentation"
    color="brand.primary.60"
    className="eyebrow-group-label"
    paddingBottom="xs"
  >
    {children}
  </Text>
);

export default EyebrowGroupLabel;
